// extracted by mini-css-extract-plugin
export default {"mainWrapper":"consignee-container_mainWrapper__oAMGy","boxWrapper":"consignee-container_boxWrapper__oADWO"};